<div class = "container">
    <div class="loading-overlay" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
    </div>

    <div
        *ngIf="showPopup"
        style="display: flex;
                position: absolute;
                top: 5%;
                width: 100%;
                height: 100px;
                align-items: center;
                justify-content: center;"
            >
        <div class="error-pop">
            <mat-icon fontIcon="error" style="margin-right: 15px;"></mat-icon>
            {{ errorString }}
        </div>
            
    </div>
    <form class = "card-form"  [formGroup]="motorFormContinued" (ngSubmit)="submitForm()" novalidate>
        <div class="blue-top"></div>
        
        <div class="card-section top-section" *ngIf="form === 'bank'">
            <h1><b>{{pageHeading}}</b></h1>
            <h2>{{bankDetailsTitle}}</h2>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected">
                    {{bankLabel}}
                </mat-label>
                <mat-select formControlName="bank" (blur)="logErrors()" panelClass="form-select-popup" (selectionChange)="populateBankBranchesList()" [disabled]="banksIsEmpty">
                    <mat-option class="form-option" [value]="banksPlaceHolder.BANKNAME" *ngFor="let banksPlaceHolder of BanksPlaceHolders">
                        {{banksPlaceHolder.BANKNAME}}
                    </mat-option>
                </mat-select>
                <span matPrefix *ngIf="loadingBanks">
                    <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
                </span>
                <mat-error *ngIf="formErrors['bank']">{{formErrors['bank']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected">
                    {{branchLabel}}
                </mat-label>
                <mat-select formControlName="branch"  panelClass="form-select-popup" (blur)="logErrors()" [disabled]="branchesIsEmpty">
                    <mat-progress-bar *ngIf="loadingBankBranches" mode="indeterminate"></mat-progress-bar>
                    <mat-option class="form-option" [value]="branchPlaceHolder" *ngFor="let branchPlaceHolder of BranchPlaceHolders">
                        {{branchPlaceHolder}}
                    </mat-option>
                </mat-select>
                <span matPrefix *ngIf="loadingBankBranches">
                    <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
                </span>
                <mat-error *ngIf="formErrors['branch']">
                    {{formErrors['branch']}}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{accountNameLabel}}</mat-label>
                <mat-hint>{{accountNameHint}}</mat-hint>
                <input matInput formControlName="accountName" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['accountName']">{{formErrors['accountName']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{accountNumLabel}}</mat-label>
                <mat-hint>{{accountNumHint}}</mat-hint>
                <input matInput formControlName="accountNum" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['accountNum']">{{formErrors['accountNum']}}</mat-error>
            </mat-form-field>

            <div class="row-div" style="margin-top: 15px; margin-bottom: 10px; max-width: 450px; justify-content: center; align-items: center;">
                <button type="button" mat-raised-button (click)="pdf.click()" style="border: 0.1px dashed rgb(194, 193, 193); width: 65px; height: 65px; border-radius: 10px;">
                    <mat-icon fontIcon="{{uploadIcon}}"></mat-icon>
                    <input type="file" (change)="openImageDialog($event)" style="display: none;" #pdf>
                </button>
                
                <div style="margin-left: 20px; width: fit-content; height: 60px;">
                    <p>{{attachDocText}}</p>
                    <div style="display: flex; margin-top: -5px;  width: 100%; justify-content: space-between;">
                        
                        <p style="color: #00518a; word-wrap: break-word; width: 80%;"><b>{{ docName }}</b></p>
                        <div *ngIf="atmOrChequeDoc.length > 5" style="cursor: pointer; color: maroon; font-weight: 600;" (click)="clearImage()">
                            {{ 'Remove' }}
                        </div>
                    </div>
                    
                </div>
                
            </div>
            
        </div>

        <div class="card-section top-section" *ngIf="form === 'glazier'">
            <h1><b>{{pageHeading}}</b></h1>
            <h2>{{glazierLabel}}</h2>

            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                    {{regionLabel}}
                </mat-label>
                <mat-select formControlName="region" (blur)="logErrors()" panelClass="form-select-popup" [disabled]="regionsIsEmpty">
                <!-- <mat-select formControlName="region" (blur)="logErrors()" panelClass="form-select-popup" (selectionChange)="populateGlaziersList()" [disabled]="regionsIsEmpty"> -->
                    <mat-option class="form-option" [value]="regionPlaceHolder" *ngFor="let regionPlaceHolder of RegionPlaceHolders">
                        {{regionPlaceHolder}}
                    </mat-option>
                </mat-select>
                <span matPrefix *ngIf="loadingRegions">
                    <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
                </span>
                <mat-error *ngIf="formErrors['region']">{{formErrors['region']}}</mat-error>
            </mat-form-field>

            <!-- <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                    {{glazierLabel}}
                </mat-label>
                <mat-select formControlName="glazier"  panelClass="form-select-popup" (blur)="logErrors()" [disabled]="glaziersIsEmpty">
                    <mat-progress-bar *ngIf="loadingGlaziers" mode="indeterminate"></mat-progress-bar>
                    <mat-option class="form-option" [value]="glazierPlaceHolder" *ngFor="let glazierPlaceHolder of GlazierPlaceHolders">
                        {{glazierPlaceHolder}}
                    </mat-option>
                </mat-select>
                <span matPrefix *ngIf="loadingGlaziers">
                    <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
                </span>
                <mat-error *ngIf="formErrors['glazier']">
                    {{formErrors['glazier']}}
                </mat-error>
            </mat-form-field> -->
        </div>

        <div class="card-section bottom-section" *ngIf="form !== 'garage'">
            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{fullNameLabel}}</mat-label>
                <input matInput  type="text" maxlength="200" formControlName="name" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['name']">{{formErrors['name']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select" appFullYearDateFormat>
                <mat-label class="form-select-placeholder-unselected">{{dateLabel}}</mat-label>
                <input matInput  [min]="minDate" [max]="maxDate" [matDatepicker]="picker" readonly="true" (click)="picker.open()" formControlName="date" (blur)="logErrors()">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker >
                </mat-datepicker>
                <mat-error *ngIf="formErrors['date']">{{formErrors['date']}}</mat-error>
            </mat-form-field>

            <div class="simple_checkbox width-100pc margin-bottom-40 margin-top-30">
                <mat-checkbox formControlName="iSwear" (blur)="logErrors()" style="margin-bottom: 10px;">
                  <p class="checkbox-p" [innerHTML]="iSwearText | dompurify"></p>
                </mat-checkbox>
                <mat-error *ngIf="formErrors['iSwear']">
                  {{formErrors["iSwear"]}}
                </mat-error>
            </div>

            <div class="row-div">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">{{cancelText}}</span>
                </button>
                <button mat-button type="submit" [disabled]="motorFormContinued.controls['iSwear'].value === false || !motorFormContinued.valid">
                    <span class="button-text">{{saveText}}</span>
                </button>
            </div>
        </div>

        <div class="card-section top-section" *ngIf="form === 'garage'" style="height: 81%; position: relative;">
            <h1><b>{{pageHeading}}</b></h1>
            <h2>{{garageLabel}}</h2>

            <div style="height: fit-content; width: 100%;">
                <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
                    <mat-label class="form-select-placeholder-unselected">
                        {{garageOptionLabel}}
                    </mat-label>
                    <mat-select formControlName="garageOption"  panelClass="form-select-popup" (blur)="logErrors()">
                        <mat-option class="form-option" [value]="garageOptions" *ngFor="let garageOptions of GarageOptions">
                            {{garageOptions}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="formErrors['garageOptions']">
                        {{formErrors['garageOptions']}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field
                    appearance="outline"
                    class="form-select"
                    style="width: 100%;"
                    *ngIf="motorFormContinued.controls['garageOption'].value === garageOptionA ||
                        motorFormContinued.controls['garageOption'].value === garageOptionB " >

                    <mat-label class="form-select-placeholder-unselected">
                        {{regionLabel}}
                    </mat-label>
                    <mat-select formControlName="region" (blur)="logErrors()" panelClass="form-select-popup" (selectionChange)="populateGaragesList()" [disabled]="regionsIsEmpty">
                        <mat-option class="form-option" [value]="regionPlaceHolder" *ngFor="let regionPlaceHolder of RegionPlaceHolders">
                            {{regionPlaceHolder}}
                        </mat-option>
                    </mat-select>
                    <span matPrefix *ngIf="loadingRegions">
                        <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
                    </span>
                    <mat-error *ngIf="formErrors['region']">{{formErrors['region']}}</mat-error>
                </mat-form-field>

                <mat-form-field
                    appearance="outline"
                    class="form-select"
                    style="width: 100%;"
                    *ngIf="motorFormContinued.controls['garageOption'].value === garageOptionA" >
                    <mat-label class="form-select-placeholder-unselected">
                        {{garageLabel}}
                    </mat-label>
                    <mat-select formControlName="garage"  panelClass="form-select-popup" (blur)="logErrors()" [disabled]="garagesIsEmpty">
                        <mat-progress-bar *ngIf="loadingGarages" mode="indeterminate"></mat-progress-bar>
                        <mat-option class="form-option" [value]="garagePlaceHolder" *ngFor="let garagePlaceHolder of GaragePlaceHolders">
                            {{garagePlaceHolder.name}}
                        </mat-option>
                    </mat-select>
                    <span matPrefix *ngIf="loadingGarages">
                        <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
                    </span>
                    <mat-error *ngIf="formErrors['garage']">
                        {{formErrors['garage']}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field
                    appearance="outline"
                    class="form-select"
                    style="width: 100%;"
                    *ngIf="motorFormContinued.controls['garageOption'].value === garageOptionB" >
                    <mat-label class="form-select-placeholder-unselected">{{
                      garageNameLabel
                    }}</mat-label>
                    <input matInput formControlName="garageName" (blur)="logErrors()" />
                    <mat-error *ngIf="formErrors['garageName']">
                      {{ formErrors["garageName"] }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field
                    appearance="outline"
                    class="form-select"
                    style="width: 100%;"
                    *ngIf="motorFormContinued.controls['garageOption'].value === garageOptionB" >
                    <mat-label class="form-select-placeholder-unselected">{{
                        garageTelLabel
                    }}</mat-label>
                    <input matInput type="tel" formControlName="garageTel" (blur)="logErrors()" />
                    <mat-hint>{{garageTelHint}}</mat-hint>
                    <mat-error *ngIf="formErrors['garageTel']">
                        {{ formErrors["garageTel"] }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div style=" display: flex; flex: 1; flex-direction: column-reverse; width: 100%;">
                <div style="width: 100%; align-items: center; justify-content: center;">
                    <div class="row-div" style="align-items: center; width: 100%;">
                        <button mat-stroked-button type="button" (click)="confirmCancel()">
                            <span class="button-text">{{cancelText}}</span>
                        </button>
                        <button mat-button type="submit" [disabled]="!motorFormContinued.valid">
                            <span class="button-text">{{saveText}}</span>
                        </button>
                    </div>
                </div>
            </div>

            
        </div>
    </form>
</div>
